    <i
      class="hx-icon {{ event.icon }}">
    </i>  
    <a
      class="cal-event-title"
      (click)="linkToRecordView()"
      [innerHTML]="event.title | calendarEventTitle:view:event">
    </a>